import { render, staticRenderFns } from "./BalanceDetailsTable.vue?vue&type=template&id=96e4c610&scoped=true"
import script from "./BalanceDetailsTable.vue?vue&type=script&lang=js"
export * from "./BalanceDetailsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e4c610",
  null
  
)

export default component.exports